import { render, staticRenderFns } from "./pbi-annual-sales-performance.page.vue?vue&type=template&id=bfd23f92"
import script from "./pbi-annual-sales-performance.page.vue?vue&type=script&lang=ts"
export * from "./pbi-annual-sales-performance.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports